import styled from "styled-components";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default InputContainer;
